import pointToLineDistance from '@turf/point-to-line-distance';
import GeoJSON from "ol/format/GeoJSON.js";
import toTurf from './toTurf.js';

export default function getPointToLineDistance(point, line, mapProjection) {
    var formatgeo = new GeoJSON();
    var lastinturf = toTurf(line, mapProjection, formatgeo);
    var nowinturf = toTurf(point, mapProjection, formatgeo);
    var distance = pointToLineDistance(nowinturf, lastinturf);
    return distance;
}
